import * as ENDPOINTS from 'constants/endpoints';
import * as CONSTANTS from 'constants';

export const fetchInputModuleList = () => {
    return {
        type: CONSTANTS.FETCH_INPUT_MODULE_LIST,
        payload: {
            url: '/inputModule/list/',
            data: {}
        }
    };
};

export const getInputModule = (data = {}) => {
    return {
        type: CONSTANTS.GET_INPUT_MODULE,
        payload: {
            url: '/inputModule/get/',
            data
        }
    };
};

// nameData is sent to the lock endpoint and detailsData to the input module endpoint; either may be omitted
export const updateInputModule = ({ nameData = null, detailsData = null } = {}) => {
    return {
        type: CONSTANTS.UPDATE_INPUT_MODULE,
        payload: {
            nameRequest: nameData ? { url: ENDPOINTS.ENDPOINT_UNIT_LOCK_EDIT, data: nameData } : null,
            detailsRequest: detailsData ? { url: '/inputModule/set/', data: detailsData } : null
        }
    };
};

export const deleteInputModule = ({ lockUUID = '' } = {}) => {
    return {
        type: CONSTANTS.DELETE_INPUT_MODULE,
        payload: {
            url: ENDPOINTS.ENDPOINT_DELETE_LOCK,
            data: { lockUUID }
        }
    };
};

export const setInputModuleByUnit = (data = {}, overwrite = {}) => {
    return {
        type: CONSTANTS.SET_INPUT_MODULE_BY_UNIT,
        payload: {
            url: '/inputModule/setByUnit/',
            data,
            overwrite
        }
    };
};

export const fetchInputModuleTypes = () => {
    return {
        type: CONSTANTS.FETCH_INPUT_MODULE_TYPES,
        payload: {
            url: '/inputModule/getTypes/',
            data: {}
        }
    };
};

export const setInputModuleRequestStatus = (status = CONSTANTS.INPUT_MODULE_REQUEST_IDLE) => {
    return {
        type: CONSTANTS.SET_INPUT_MODULE_REQUEST_STATUS,
        payload: status
    };
};

export const setInputModuleList = (data = []) => {
    return {
        type: CONSTANTS.SET_INPUT_MODULE_LIST,
        payload: data
    };
};

export const setInputModuleHeaders = (data) => {
    return {
        type: CONSTANTS.SET_INPUT_MODULE_HEADERS,
        payload: data
    };
};

export const setInputModuleDetails = (data = null) => {
    return {
        type: CONSTANTS.SET_INPUT_MODULE_DETAILS,
        payload: data
    };
};

export const setInputModuleTypes = (data = []) => {
    return {
        type: CONSTANTS.SET_INPUT_MODULE_TYPES,
        payload: data
    };
};
